// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"64014b47","2130":"5da695e7","5338":"3196443d","8237":"7ded952d"}[chunkId] + ".chunk.css";
};